import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as globalAdd from '../../../connectionString';

@Injectable()
export class HaFeedbackserviceService {

  constructor(private http: HttpClient) { }
  getDoctorsList() {
    return this.http.get(globalAdd.Paneladdress + 'api/HA/Feedback/getDoctorsList');
  }

  getFeedbackData() {
    return this.http.get(globalAdd.Paneladdress + 'api/HA/Feedback/getFeedbackData');
  }

}
